/**
 * Sites (gateway-cloud) — cloud-mode site selector (R-021). Already cloud-shaped (`/users/...`), so
 * resolvePath passes them through unchanged. Only ever called in cloud mode.
 */
export const siteEndpoints = {
  list: '/users/v1/sites',
  one: (id: string) => `/users/v1/sites/${id}`,
  // R-150 admin surface
  manage: '/users/v1/sites/manage',
  create: '/users/v1/sites',
  update: (id: string) => `/users/v1/sites/${id}`,
  enrollment: (id: string) => `/users/v1/sites/${id}/enrollment`,
} as const;
